var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioCallsMade(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#FAF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5241 23.807C21.6962 23.886 21.8901 23.9041 22.0738 23.8582C22.2575 23.8123 22.4202 23.7052 22.5349 23.5545L22.8307 23.167C22.986 22.96 23.1873 22.792 23.4187 22.6763C23.6501 22.5606 23.9053 22.5003 24.1641 22.5003H26.6641C27.1061 22.5003 27.53 22.6759 27.8426 22.9885C28.1551 23.301 28.3307 23.725 28.3307 24.167V26.667C28.3307 27.109 28.1551 27.5329 27.8426 27.8455C27.53 28.1581 27.1061 28.3337 26.6641 28.3337C22.6858 28.3337 18.8705 26.7533 16.0575 23.9403C13.2444 21.1272 11.6641 17.3119 11.6641 13.3337C11.6641 12.8916 11.8397 12.4677 12.1522 12.1551C12.4648 11.8426 12.8887 11.667 13.3307 11.667H15.8307C16.2728 11.667 16.6967 11.8426 17.0092 12.1551C17.3218 12.4677 17.4974 12.8916 17.4974 13.3337V15.8337C17.4974 16.0924 17.4372 16.3476 17.3214 16.579C17.2057 16.8104 17.0377 17.0117 16.8307 17.167L16.4407 17.4595C16.2877 17.5763 16.1799 17.7425 16.1356 17.9298C16.0912 18.1171 16.113 18.314 16.1974 18.487C17.3363 20.8002 19.2094 22.671 21.5241 23.807Z",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioCallsMade);
export default __webpack_public_path__ + "static/media/audio-calls-made.2a05c0a511d4527fc04eabc2e20c74ea.svg";
export { ForwardRef as ReactComponent };